export const OauthCallbackState = {
  LOADING: "LOADING",
  COMPLETE: "COMPLETE",
  ERROR: "ERROR",
};